import React, { useEffect, useRef, useState } from 'react'
import '../styles/SignUp.css'
import logo from "../imgs/logo.png"
import API from '../APIs/MainAPI'
import { useNavigate } from 'react-router-dom'

const SignUp = ({rawData, userData, setUserData}) => {

  const navigate = useNavigate()

  useEffect(() => {
      if(userData?.firstName || userData?.secondName) navigate('/');
    }, [])

  const [firstName, setFirstName] = useState("")
  const [secondName, setSecondName] = useState("")
  const [thirdName, setThirdName] = useState("")
  const [birthDate, setBirthDate]= useState("")

  const adminSignUp = () => {
    let userDataNew = {
      firstName: firstName,
      secondName: secondName,
      thirdName: thirdName,
      birthDate: birthDate
    }
    API.SignUp(rawData, userDataNew).then((data) => {
      // console.log(data);
      if(data.status == 200){
        setUserData(data.res.data)
        navigate('/')
      }
    }).catch((e) => {
      console.error(e)
    })
  }

  return (
    <div className='authCont'>
        <div className="authCard">
            <div className="authCardBg">
                <div className="authCardCont">
                    <div className="topauth">
                      <h1>Вход</h1>
                      <img src={logo} alt="logo" />
                    </div>
                    <input type="text" className='authInput'
                        placeholder='Фамилия' value={firstName} onChange={(e) => setFirstName(e.target.value)}
                    />
                    <input type="text" className='authInput'
                        placeholder='Имя' value={secondName} onChange={(e) => setSecondName(e.target.value)}
                    />
                    <input type="text" className='authInput'
                        placeholder='Отчество' value={thirdName} onChange={(e) => setThirdName(e.target.value)}
                    />
                    <h3 className='SignInBD'>Дата рождения:</h3>
                    <input type="date" className='authInput'
                        placeholder='Дата рождения' value={birthDate} onChange={(e) => setBirthDate(e.target.value)}
                    />
                    <div className="buttonCont">
                      <button className='admButton' 
                        disabled={firstName.length !== 0 && secondName.length !== 0 && thirdName.length !== 0 && birthDate.length !== 0 ? false : true} 
                        onClick={() => adminSignUp()
                      }>Вход</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SignUp